import React from 'react'
import { UpgradeTideways6 } from './UpgradeTideways6'

interface Props {
    newPlan: string
    upgrade: UpgradeTideways6
    actionUrl: string
    onTeamsChange: (teams: number) => void
}
interface StateProps {
    teams: number
}

class ReviewTeams extends React.Component<Props, StateProps> {
    constructor(props: Props) {
        super(props)

        this.state = {
            teams: this.props.upgrade.teamsCount,
        }
    }

    public onTeamsChange(ev) {
        let teams = parseInt(ev.target.value)

        if (teams < this.props.upgrade.teamsCount) {
            teams = this.props.upgrade.teamsCount
        }

        this.setState({ teams })
        this.props.onTeamsChange(teams)
    }

    public render() {
        const includedTeams = {
            tideways6_starter: 1,
            tideways6_basic: 1,
            tideways6_standard: 1,
            tideways6_pro: 5,
            tideways7_basic: 1,
            tideways7_standard: 1,
            tideways7_pro: 5,
            tideways8_team: 1,
            tideways8_business: 5,
            tideways8_enterprise: 5,
        }

        const includedTeamCount = includedTeams[this.props.newPlan] || 1
        const membersUrl = this.props.actionUrl.replace('/billing/upgrade', '/members').replace('/checkout/start', '/members')
        const requiredTeamAddons = Math.max(0, this.state.teams - includedTeamCount)

        return this.props.upgrade.hasTeamAccess ? (
            <div>
                <h3>Review Teams</h3>

                <div className="box">
                    <div className="box-body box-body-larger">
                        <div className="row">
                            <div className="col-lg-4">
                                <input type="range" min="1" max="20" onInput={ev => this.onTeamsChange(ev)} value={this.state.teams} />
                                <div>
                                    <big>{this.state.teams}</big> teams
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <p>Teams allow you to organize project-access and notifications for unlimited users.</p>

                                <p>
                                    You currently have <a href={membersUrl}>created {this.props.upgrade.teamsCount} teams </a>
                                    in this organization. The selected plan includes {includedTeamCount} teams.{' '}
                                    <strong>{requiredTeamAddons}</strong> team add-ons are added to your plan.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : null
    }
}

export default ReviewTeams
